import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {autobind} from 'core-decorators';
import ClipboardJS from 'clipboard';

import {Tooltip, CustomComponent} from '../../common/components';
import {CodeBlock} from './CodeBlock';


export class ExampleCode extends Component<jsx.Props, jsx.State> {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            current: 'curl',
        };
    }

    @autobind
    handleCodeSelection(language: string) {
        return () => {
            this.setState({
                current: language,
            });
        };
    }

    isSelected(language: string) {
        if (language === this.state.current) {
            return 'selected';
        } else {
            return '';
        }
    }

    render() {
        const code = this.props.code[this.state.current];

        return (
            <div className="code-example wide">
                <h3>EXAMPLE REQUESTS</h3>

                <div className="code-options">
                    <div className={`code-option ${this.isSelected('curl')}`} onClick={this.handleCodeSelection('curl')}>Curl</div>
                    <div className={`code-option ${this.isSelected('python')}`} onClick={this.handleCodeSelection('python')}>Python</div>
                    <div className={`code-option ${this.isSelected('java')}`} onClick={this.handleCodeSelection('java')}>Android/Java</div>
                    <div className={`code-option ${this.isSelected('swift')}`} onClick={this.handleCodeSelection('swift')}>Swift 2.0+ / iOS</div>
                    <div className={`code-option ${this.isSelected('javascript')}`} onClick={this.handleCodeSelection('javascript')}>Javascript</div>
                    <div className={`code-option ${this.isSelected('objectivec')}`} onClick={this.handleCodeSelection('objectivec')}>Objective-C</div>
                </div>

                <div className="code-box">
                    <CodeBlock code={code} language={this.state.current}/>
                    <div className="code-box-bottom">
                        <CodeCopyButton
                            text={this.props.code[this.state.current]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


class CodeCopyButton extends CustomComponent {
    activateTooltip?: (...args: any[]) => void;
    node: null|HTMLElement;
    clipboard?: ClipboardJS;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.node = null;
    }
    componentDidMount() {
        this.clipboard = new ClipboardJS(this.node);
        this.clipboard.on('success', this.activateTooltip);
    }
    componentWillUnmount() {
        this.clipboard?.destroy();
    }
    @autobind
    handleClick(event: Event) {}
    render() {
        return (
            <div className="CodeCopy">
                <Tooltip
                    msg={'Copied to clipboard'}
                    addTooltipActivationCallback={(callback) => {
                        this.activateTooltip = callback;
                    }}
                />
                <button
                    onClick={this.handleClick}
                    ref={(node) => {
                        return this.node = node;
                    }}
                    data-clipboard-text={this.props.text}
                >
                    Copy
                </button>
            </div>
        );
    }
}
